import { getNowDateTimeUTC } from '@sales-center/common'
import { ActivityStatus } from '@user/features/Activity'

export function getFilterArray(userId: string): string[] {
  return [`(ownerId eq ${userId})`]
}

export function getOverDueFilter(): string {
  const now = new Date()
  const pastDue = `dueDate le ${getNowDateTimeUTC(now)}`
  const notComplete = `status ne '${ActivityStatus.Complete}'`
  const notDeferred = `status ne '${ActivityStatus.Deferred}'`

  return `(${pastDue} and ${notComplete} and ${notDeferred})`
}
